import { ActivityLogBody } from './ActivityLogBody'

/**
 * The COMPANY audit log — Settings → Activity Log. Company-wide (no fixed actor):
 * company_updated, user_added, permissions_updated, role_added, payment_method_updated.
 *
 * The actual list/search/sort/filter/export body is shared with Personal → Activity
 * (`ActivityLogBody`), which pins `fixedActorId` to the signed-in user instead —
 * see that file's docblock and VRG-338. Kept as its own thin component (rather than
 * having callers reach for `ActivityLogBody` directly) so the two settings-menu
 * entries stay simple one-line `component:` values, matching every other section.
 */
export const ActivityLogPage = () => <ActivityLogBody />
